import { render } from "./BookDetailsPage.vue?vue&type=template&id=e86fd9b0&scoped=true"
import script from "./BookDetailsPage.vue?vue&type=script&lang=js"
export * from "./BookDetailsPage.vue?vue&type=script&lang=js"

import "./BookDetailsPage.vue?vue&type=style&index=0&id=e86fd9b0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e86fd9b0"]])

export default __exports__